import SceTextBoxComponent from "../../Common/TextBox/sceText";
import classes from "./bpMatchForm.scss";
import SceButton from "../../Common/CommonComponents/sceButton.js";
import { getLocalizedStrings } from "../centralizedLocalizedString.js";
const BpMatchForm = (props) => {
  let strings = getLocalizedStrings("ErrorCard");
  return (
    <div className={classes.bpMatchForm}>
      <label className={classes.bpMatchLabel}> {strings.FirstName}</label>
      <SceTextBoxComponent
        defaultValue={props.firstName}
        id="firstName"
        type="firstName"
        onTextUpdatedHandler={props.retrieveInputData}
        forceValidate={false}
        validator={app.appUtil.validator}
      />
      <label className={classes.bpMatchLabel}> {strings.LasttName}</label>
      <SceTextBoxComponent
        defaultValue={props.lastName}
        id="lastName"
        type="lastName"
        onTextUpdatedHandler={props.retrieveInputData}
        forceValidate={false}
        validator={app.appUtil.validator}
      />
      <label className={classes.bpMatchLabel}> {strings.Email}</label>
      <SceTextBoxComponent
        defaultValue={props.emailId}
        id="email"
        type="email"
        isEmail
        onTextUpdatedHandler={props.retrieveInputData}
        forceValidate={false}
        validator={app.appUtil.validator}
        onKeyPressHandler={(e) => {
          if (e.key === ' ') {
              e.preventDefault();
          }
        }}
      />
      <div className={classes.btnText}>
        <SceButton
          id="identity"
          iconType="rightArrow"
          buttonType="default"
          value="Continue"
          isDisabled={props.profileData.isError}
          onClick={() => props.disp()}
        />
      </div>
    </div>
  );
};

export default BpMatchForm;
